import Logo from '../../Assets/LOGO_BIND_TRACK-02.png'
import * as S from './Header.style'

export const Header = () => {

  const handleMenuClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <S.Wrapper className=''>
      <img
        src={Logo}
        alt="logo"
        className='
          w-[250px]
          md:w-[150px]
          lg:w-[184px]
          xl:w-[250px]
        '
      />

      <S.BtnBox>
        <S.Btn
          onClick={() => handleMenuClick("Benefits")}
        >
          DESAFIOS
        </S.Btn>
        <S.Btn
          onClick={() => handleMenuClick("Solution")}
        >
          SOLUÇÃO
        </S.Btn>
        <S.Btn
          onClick={() => handleMenuClick("Operation")}
        >
          COMO FUNCIONA
        </S.Btn>
        <S.Btn
          onClick={() => handleMenuClick("Implementation")}
        >
          IMPLEMENTAÇÃO
        </S.Btn>
        <S.Btn
          onClick={() => handleMenuClick("Contact")}
        >
          CONTATO
        </S.Btn>

      </S.BtnBox>
    </S.Wrapper>
  )
}
